// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class APNSDeviceResource extends Resource {
    basePath: string = 'notifications/device/apns/';

    objectPath: string = 'notifications/device/apns/{ident}/';
}
